<template>
	<v-container fluid class="py-0 my-0">
		<v-row justify="center" class=" py-0 my-0">
			<v-col cols="12" class="py-0 my-0">

				<v-row justify="center" class=" py-0 my-0">
					<v-col cols="9" class="py-0 my-0">
						<v-alert
							border="left"
							color="primary"
							dense outlined text>
							<v-row>
								<v-col  class="d-flex align-center" cols="2">
									<v-btn fab x-small  @click="showDatesAlert=true" color="primary">
										<v-icon color="secondary">mdi-calendar</v-icon>
									</v-btn>
									<v-btn fab x-small @click="showDatesAlert=false" color="primary">
										<v-icon color="secondary">mdi-currency-eur</v-icon>
									</v-btn>
								</v-col>
								<v-col cols="9">
									<div class="mt-1" v-if="showDatesAlert===true">
										<span >
											Αλλαγές επιτρέπονται στο διάστημα από <strong>{{$store.getters.homePageInformation.configuration.LibraryOrderFromDate}}</strong>
											έως <strong>{{$store.getters.homePageInformation.configuration.LibraryOrderToDate}}</strong>
										</span>
									</div>
									<div class="mt-1" v-else>
										<span v-html="returnAlertText()"/>
									</div>
								</v-col>
							</v-row>
						</v-alert>
					</v-col>
				</v-row>


				<v-row justify="center" class=" pt-0 mt-0">
					<v-col cols="9" class="pt-0 mt-0">
						<v-container fluid style="background-color: #3AA8C3 ">
							<v-row >
								<v-col cols="5" style="max-height: 46px" class="mb-2">
									<v-select :items="$store.getters.yearsInfo.yearsList" outlined dense height="25" color="black"
									          v-model="selectedYear" item-value="year" item-text="yearLabel" @change="changeYear($event)"
									          label="Ακαδ. Έτος"/>
								</v-col>


								<v-col cols="3" style="max-height: 46px">
									<v-btn v-if="Object.keys($store.getters.homePageInformation.bookSupplier).length>0 && $store.getters.homePageInformation.bookSupplier.type === 'Library'"
										   @click="addOrder" style="border: 2px solid black"> Προσθήκη<v-icon>mdi-file-plus</v-icon></v-btn>
								</v-col>

								<v-col cols="3" style="max-height: 46px">
									<v-btn @click="getExcel" style="border: 2px solid black"> Εξαγωγή Αρχείου<v-icon>mdi-file-excel</v-icon></v-btn>
								</v-col>

							</v-row>
						</v-container>


					</v-col>
				</v-row>

				<v-row cols="12">
					<v-col cols="12">
						<v-data-table :style="{width:'100%'}" :headers="headers" :items="filteredItems" :key="tableKey"
						              :footer-props="{
                                                itemsPerPageOptions:[10,25,50],
                                                'items-per-page-text':'Ανά γραμμή',
                                                prevIcon: 'mdi-arrow-left-bold',
                                                nextIcon: 'mdi-arrow-right-bold',
                                            }"  class="black--text">

							<template v-slot:body.prepend>
								<tr>
									<td style="height: 43px" class="black--text text-center d-sm-table-cell d-flex">
										<v-autocomplete style="font-size: 12px" item-value="name" item-text="name" :items="institutionItems" v-model="institutionFilter" hide-details dense/>
									</td>
									<td style="height: 43px" class="black--text text-center d-sm-table-cell d-flex">
										<v-autocomplete style="font-size: 12px" item-value="department " item-text="department" :items="departmentItems" v-model="departmentFilter" hide-details dense/>
									</td>
									<td style="height: 43px" class="black--text text-center d-sm-table-cell d-flex">
										<v-autocomplete style="font-size: 12px" item-value="name" item-text="name" :items="libraryItems" v-model="libraryFilter" hide-details dense/>
									</td>
									<td style="height: 43px" class="black--text text-center d-sm-table-cell d-flex">
										<v-text-field style="font-size: 12px" v-model="bookFilter" hide-details dense/>
									</td>
									<td style="height: 43px" class="black--text text-center d-sm-table-cell d-flex"></td>
									<td style="height: 43px" class="black--text text-center d-sm-table-cell d-flex"></td>
									<td style="height: 43px" class="black--text text-center d-sm-table-cell d-flex">
										<v-select style="font-size: 12px" :items="statusFilterItems" item-text="label" item-value="value" v-model="statusFilter" hide-details dense/>
									</td>
									<td style="height: 43px" class="black--text text-center d-sm-table-cell d-flex">
										<v-btn small color="primary" outlined @click="clearFilters"><v-icon>mdi-broom</v-icon></v-btn>
									</td>
								</tr>
							</template>

							<template v-slot:item="{ item, index }">
								<tr :class="item.id == selectedOrderId ? 'cyan lighten-4 black--text' : ''" @click="selectLine(item, index)">
									<td style="height: 43px;font-size: 11px" class="black--text text-center d-sm-table-cell d-flex">{{ item.institutionName }}</td>
									<td style="height: 43px;font-size: 11px" class="black--text text-center d-sm-table-cell d-flex">{{ item.academicName }}</td>
									<td style="height: 43px;font-size: 11px" class="black--text text-center d-sm-table-cell d-flex">{{ item.libraryName }}</td>
									<td style="height: 43px;font-size: 11px;max-width: 200px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;" class="black--text text-center d-sm-table-cell d-flex">[{{ item.bookId }}] {{item.bookTitle}}</td>
									<td style="height: 43px;font-size: 11px" class="black--text text-center d-sm-table-cell d-flex">{{ item.amount }}</td>
									<td style="height: 43px;font-size: 11px" class="black--text text-center d-sm-table-cell d-flex">{{ item.pricePerItem }}</td>
									<td style="height: 43px;font-size: 11px" class="black--text text-center d-sm-table-cell d-flex">{{ returnOrderStatus(item.status) }}</td>
									<td style="height: 43px;font-size: 11px" class="black--text text-center d-sm-table-cell d-flex">{{ item.statusDateString }}</td>



								</tr>
							</template>
						</v-data-table>
					</v-col>
				</v-row>

			</v-col>
		</v-row>
		<OrderDialog :key="orderDialogKey" :libraries="libraryItems" :departments="departmentItems" @save-order="afterSaveOrder"
                     :order="selectedOrder" :orderIndex="selectedOrderIndex" @delete-order="removeDeletedOrder"
                     :ordersCostBalance="ordersCostBalance"/>
	</v-container>
</template>

<script>
	import requests from "../requests";
	import ConfirmDialogue from "./ConfirmDialog";
	import OrderDialog from "./OrderDialog";

	export default {
		name: "LibraryOrders",
		components: {OrderDialog, ConfirmDialogue},
		data: () => ({
			orderDialogKey:0,
			tableKey:0,
			institutionFilter:'',
			departmentFilter:'',
			libraryFilter:'',
			bookFilter:'',
			statusFilter:'',
			statusFilterItems:[
				{value:'Approved', label:'Εγκεκριμένη'},
				{value:'Pending', label:'Προετοιμασία για αποστολή'},
				{value:'Completed', label:'Ολοκληρώθηκε'},
				{value:'Expired', label:'Έχει λήξει'},
			],
			selectedOrderId:0,
			selectedOrderIndex:null,
			selectedOrder:{},
			asyncResponses:0,
			showDatesAlert:true,
	        selectedYear:'',
			institutionItems:[],
			libraryItems:[],
			departmentItems:[],
			amountLimit:null,
			ordersCostBalance:null,
			ordersCostLimit:null,
			ordersCostSum:null,
            publisherInfo:{},
	        showYearFilter:true,
			pinDialog:false,
			pin: '',
	        orders:[],
	        headers: [
		        { text: 'Ίδρυμα', value: 'institutionName', align: 'center', sortable: true, width: '15%'},
		        { text: 'Τμήμα', value: 'academicName', align: 'center', sortable: true, width: '25%'},
		        { text: 'Βιβλιοθήκη', value: 'libraryName', align: 'center', sortable: true, width: '22%'},
		        { text: 'Βιβλίο', value: 'id', align: 'center', sortable: true, width: '25%'},
		        { text: 'Τεμάχια', value: 'amount', align: 'center', sortable: true, width: '1%'},
		        { text: 'Κόστος', value: 'pricePerItem', align: 'center', sortable: true, width: '2%'},
		        { text: 'Κατάσταση', value: 'status', align: 'center', sortable: true, width: '5%'},
		        { text: 'Ημερομηνία', value: 'statusDate', align: 'center', sortable: true, width: '5%'},
	        ],
		}),

		computed: {
			filteredItems() {
				return this.orders.filter(item => {
						let institutionFilterMatch = false;
						let departmentFilterMatch = false;
						let libraryFilterMatch = false;
						let bookFilterMatch = false;
						let statusFilterMatch = false;

						if (this.institutionFilter === '') {
							institutionFilterMatch = true;
						} else {
							if (this.institutionFilter === item.institutionName) {
								institutionFilterMatch = true;
							}
						}
						if (this.departmentFilter === '') {
							departmentFilterMatch = true;
						} else {
							if (this.departmentFilter === item.academicName) {
								departmentFilterMatch = true;
							}
						}
						if (this.libraryFilter === '') {
							libraryFilterMatch = true;
						} else {
							if (this.libraryFilter === item.libraryName) {
								libraryFilterMatch = true;
							}
						}
						if (this.bookFilter === '') {
							bookFilterMatch = true;
						} else {
							if (item.bookId.toString().includes(this.bookFilter.toString())) {
								bookFilterMatch = true;
							}
						}
						if (this.statusFilter === '') {
							statusFilterMatch = true;
						} else {
							if (this.statusFilter === item.status) {
								statusFilterMatch = true;
							}
						}


						return institutionFilterMatch && departmentFilterMatch && libraryFilterMatch && bookFilterMatch && statusFilterMatch;
					});
			}
		},

        methods:{
	        afterSaveOrder(data){
				this.getLibraryOrdersCallBack(data, false);
            },

			removeDeletedOrder(index){
				this.orders.splice(index, 1);
				let filteredItemsIndex=null;
				for(let k=0; k<this.filteredItems.length;k++){
					if(this.filteredItems.id == this.selectedOrderId){
						filteredItemsIndex = k;
						break;
                    }
                }
				this.filteredItems.splice(filteredItemsIndex, 1);
				this.tableKey++;
				this.$store.commit('setOrderDialog', false);
			},

			selectLine(item, index){
				if(Object.keys(this.$store.getters.homePageInformation.bookSupplier).length>0 && this.$store.getters.homePageInformation.bookSupplier.type === 'Library'){
					this.selectedOrderId = item.id;
					this.selectedOrder = item;
					this.selectedOrderIndex = index;
					this.orderDialogKey++;
					this.$store.commit('setOrderDialog', true);
				}
			},

			addOrder(){
				if(Object.keys(this.$store.getters.homePageInformation.bookSupplier).length>0 && this.$store.getters.homePageInformation.bookSupplier.type === 'Library'){
					this.selectedOrderId = 0;
					this.selectedOrder = {};
					this.selectedOrderIndex = null;
					this.orderDialogKey++;
					this.$store.commit('setOrderDialog', true)
				}
			},

			clearFilters(){
				this.institutionFilter = '';
				this.departmentFilter = '';
				this.libraryFilter = '';
				this.bookFilter = '';
				this.statusFilter = '';
			},

			returnOrderStatus(type){
				if(type === 'Approved') {
					return 'Εγκεκριμένη'
				}
				else if(type === 'Pending') {
					return 'Προετοιμασία για αποστολή'
				}
				else if(type === 'Completed') {
					return 'Ολοκληρώθηκε'
				}else if(type === 'Expired') {
					return 'Έχει λήξει'
				}else {
					return '--';
				}
			},

	        changeYear(year){
		        this.selectedYear = year;
		        this.getLibraryOrders(false);
	        },

	        getLibraryOrders(asyncResp){
		        this.$store.commit('setLoadingModal', true);
		        requests.get('rest/library-orders/' + this.selectedYear, (resp) =>{
			        this.getLibraryOrdersCallBack(resp, asyncResp);

		        })
	        },

			getLibraryOrdersCallBack(resp, asyncResp){
				this.orders = resp.orders;
				this.amountLimit = resp.amountLimit;
				this.ordersCostBalance = resp.ordersCostBalance;
				this.ordersCostLimit = resp.ordersCostLimit;
				this.ordersCostSum = resp.ordersCostSum;
				if(asyncResp){
					this.asyncResponses++;
				}else{
					this.$store.commit('setLoadingModal', false);
				}
			},

	        getInstitutions(){
                requests.get('rest/library-orders/institutions', (resp) =>{
					if(typeof resp === "object" && resp !== null){
						this.institutionItems = [];
						this.institutionItems.push(JSON.parse(JSON.stringify(resp)));
					}else{
						this.institutionItems = JSON.parse(JSON.stringify(resp));
					}

	                this.asyncResponses++;
                });
	        },

	        getLibraries(){
                requests.get('rest/library-orders/libraries', (resp) =>{
	                this.libraryItems = JSON.parse(JSON.stringify(resp));
	                this.asyncResponses++;
                });
	        },

	        getDepartments(){
                requests.get('rest/library-orders/academics', (resp) =>{
	                this.departmentItems = JSON.parse(JSON.stringify(resp));
	                this.asyncResponses++;
                });
	        },

	        returnAlertText(){
		        if(this.$store.getters.homePageInformation.bookSupplier.type !== 'Ministry'){
		        	let text = '';
		        	if(this.selectedYear == this.$store.getters.homePageInformation.configuration.ACTIVE_YEAR){
		        		text += 'Το υπόλοιπο κόστος παραγγελιών για αυτό το ακαδημαϊκό έτος είναι <strong>' + (this.ordersCostBalance==null? 0:this.ordersCostBalance) +'</strong> Ευρώ.<br/>' +
								'Το μέγιστο κόστος παραγγελιών για αυτό το ακαδημαϊκό έτος έχει οριστεί στα <strong>' + (this.ordersCostLimit==null? 0:this.ordersCostLimit) +'</strong> Ευρώ.<br/>' +
								'Κάθε παραγγελία μπορεί να περιέχει το πολύ μέχρι <strong>' + (this.amountLimit==null?0:this.amountLimit) +'</strong> τεμάχια (βιβλία) <br/>';
					}
					text += 'Το κόστος παραγγελιών για αυτό το ακαδημαϊκό έτος είναι <strong>'+ (this.ordersCostSum==null? 0:this.ordersCostSum) + '</strong> Ευρώ.<br/>';
		        	return text;
		        }else{
					return 'Το κόστος παραγγελιών για αυτό το ακαδημαϊκό έτος είναι <strong>' + (this.ordersCostSum==null?0: this.ordersCostSum )+ '</strong> Ευρώ.';
		        }
	        },

	        async acceptOrder(item){
		        document.activeElement.blur();
		        const ok = await this.$refs.confirmDialog.show({
			        message: 'Είστε σίγουρος/η ότι θέλετε να αποδεχθείτε την παραγγελία;'
		        });

		        if(ok){
			        this.$store.commit('setLoadingModal', true);
                    requests.post('rest/library-orders/accept', item.id, () =>{
                    	this.getLibraryOrders();
                    });

		        }
	        },

	        async cancelOrder(item){
		        document.activeElement.blur();
		        const ok = await this.$refs.confirmDialog.show({
			        message: 'Είστε σίγουρος/η ότι θέλετε να ακυρώσετε την παραγγελία;'
		        });

		        if(ok){
			        this.$store.commit('setLoadingModal', true);
                    requests.post('rest/library-orders/cancel', item.id, () =>{
                    	this.getLibraryOrders();
                    });

		        }
	        },

			returnStatusText(status){

				if(status === 'NotApproved') {
					return 'Μη εγκεκριμένη'
				}
				else if(status === 'Approved') {
					return 'Εγκεκριμένη'
				}
				else if(status === 'Pending') {
					return 'Προετοιμασία για αποστολή'
				}
				else if(status === 'Completed') {
					return 'Ολοκληρωμένη'
				}else {
					return '--';
                }
            },

			getExcel(){
				this.$store.commit('setLoadingModal', true);
				requests.getReports('rest/library-orders/excel/' + this.selectedYear)
			},

        },

		watch:{
			'asyncResponses': function(val) {
				if(val===4) {
					this.$store.commit('setLoadingModal', false);
					this.asyncResponses=0;
				}

			}
		},

        created() {
	        this.selectedYear = this.$store.getters.yearsInfo.yearsList[0].year == this.$store.getters.homePageInformation.configuration.ACTIVE_YEAR?
				this.$store.getters.yearsInfo.yearsList[0].year : this.$store.getters.yearsInfo.yearsList[1].year;
			// this.selectedYear = 2023;
			this.getLibraryOrders(true);
	        this.getInstitutions();
		    this.getLibraries();
	        this.getDepartments();
        }
	}
</script>

<style scoped>

</style>






